/*
 * LIFTED PLACEHOLDER REGISTRY — client-side (_live) resolver.
 * ---------------------------------------------------------------------------
 * Full registry + naming convention: see LIFTED_PLACEHOLDERS.md.
 * (Distinct from assets/lifted-tokens.css, which is the CSS *design-token*
 * system — colors/spacing/type. These are merge-tag placeholders in copy.)
 *
 * Placeholders are `{placeholder.<domain>.<name>}` merge tags embedded in
 * Transcy-translatable copy. Server-resolved ones (no `_live` suffix) are
 * filled in Liquid by snippets/lifted-placeholders.liquid. The `_live`
 * placeholders below carry per-visitor values from the architect shipping API
 * and MUST be filled at runtime — never use them in plain static content.
 *
 * Adding a new client placeholder: add one entry to RESOLVERS keyed by the
 * exact `{placeholder.…_live}` string, returning a formatted string or null
 * (null => the caller falls back to a complete sentence).
 */
(function () {
  function fmtPrice(value, currency, locale) {
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(value);
    } catch (_) {
      return currency + ' ' + value;
    }
  }

  // Shared, locale-aware date formatter — the ONE place dates are formatted.
  // Accepts an ISO date string OR a Date (so callers doing offset math can pass
  // a Date). Default = long form ("Friday, 5 June" / "piątek, 5 czerwca");
  // pass style 'short' for compact ("5 Jun" / "5 cze") where space is tight
  // (e.g. the pre-order batch bars). Intl localizes weekday/month per language.
  // Noon UTC + timeZone:UTC avoids day-boundary drift.
  function formatDate(input, locale, style) {
    locale = locale || (document.documentElement.lang || 'en');
    try {
      var d = (input instanceof Date) ? input : new Date(input + 'T12:00:00Z');
      var opts = (style === 'short')
        ? { day: 'numeric', month: 'short', timeZone: 'UTC' }
        : { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' };
      return new Intl.DateTimeFormat(locale, opts).format(d);
    } catch (_) {
      return '';
    }
  }

  // Registry of client-resolved (_live) placeholders. Each fn returns a string,
  // or null when the live data can't satisfy it (caller uses its fallback).
  var RESOLVERS = {
    '{placeholder.ship.price_live}': function (data, locale) {
      var c = data && data.cheapest;
      if (!data || !data.available || !c) return null;
      if (typeof c.price_display !== 'number' || !c.display_currency) return null;
      return fmtPrice(c.price_display, c.display_currency, locale);
    },
    '{placeholder.ship.eta_live}': function (data, locale) {
      var c = data && data.cheapest;
      if (!data || !data.available || !c) return null;
      var iso = c.arrival_date_iso || c.preorder_arrival_date_iso;
      var out = iso ? formatDate(iso, locale) : '';
      // Only use the API's English display string on English locales — otherwise
      // an English date would leak into translated copy. Returning null makes the
      // caller fall back to its fully-translated sentence instead.
      if (!out && (locale || '').slice(0, 2).toLowerCase() === 'en') out = c.arrival_display_en || '';
      return out || null;
    }
  };

  window.LiftedPlaceholders = {
    /* Shared locale-aware date formatter (ISO string or Date) — one source for
       every surface to call. Long form, localized per <html lang>. */
    formatDate: formatDate,
    /* True if `text` contains any registered _live placeholder. */
    hasLive: function (text) {
      if (!text) return false;
      for (var k in RESOLVERS) { if (text.indexOf(k) !== -1) return true; }
      return false;
    },
    /* Replace every _live placeholder in `text`. Returns the filled string, or
       null if any present placeholder can't resolve (so the caller falls back). */
    fill: function (text, data, locale) {
      locale = locale || (document.documentElement.lang || 'en');
      var out = text;
      for (var token in RESOLVERS) {
        if (out.indexOf(token) === -1) continue;
        var val = RESOLVERS[token](data, locale);
        if (val == null) return null;
        out = out.split(token).join(val);
      }
      return out;
    }
  };
})();
